import { default as _91_46_46_46slug_93yri8I4l3CyMeta } from "/opt/simploshop/shared/core-theme/app/pages/[...slug].vue?macro=true";
import { default as deliveryzZp5D5FhEdMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/cart/delivery.vue?macro=true";
import { default as indexHcr3N6bMoIMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/cart/index.vue?macro=true";
import { default as payment_45summaryaFmU9qqADHMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/cart/payment-summary.vue?macro=true";
import { default as shipping_45and_45paymentYGgVm39oA9Meta } from "/opt/simploshop/themes/theme-default-clean/app/pages/cart/shipping-and-payment.vue?macro=true";
import { default as summaryW53CX9JalVMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/cart/summary.vue?macro=true";
import { default as cartGiCcjada9VMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/cart.vue?macro=true";
import { default as accountZ04vUrTNJPMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/account.vue?macro=true";
import { default as dashboardYhCq46WyD4Meta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/dashboard.vue?macro=true";
import { default as favorite_45productsQZ3R45QIPkMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/favorite-products.vue?macro=true";
import { default as my_45addressesbumAp6EGtkMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-addresses.vue?macro=true";
import { default as _91id_93ySIEyIVdJkMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/[id].vue?macro=true";
import { default as indexpV1IEGU3MXMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/index.vue?macro=true";
import { default as my_45ordersRlXvFm5K0LMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders.vue?macro=true";
import { default as customerFdSSXYej6eMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/customer.vue?macro=true";
import { default as indexeq1O9kIMLeMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/index.vue?macro=true";
import { default as loginYQ645hBCn8Meta } from "/opt/simploshop/themes/theme-default-clean/app/pages/login.vue?macro=true";
import { default as password_45resetACf7izeVLdMeta } from "/opt/simploshop/themes/theme-default-clean/app/pages/password-reset.vue?macro=true";
export default [
  {
    name: "slug___cs",
    path: "/:slug(.*)*",
    component: () => import("/opt/simploshop/shared/core-theme/app/pages/[...slug].vue")
  },
  {
    name: "slug___sk",
    path: "/:slug(.*)*",
    component: () => import("/opt/simploshop/shared/core-theme/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/opt/simploshop/shared/core-theme/app/pages/[...slug].vue")
  },
  {
    name: cartGiCcjada9VMeta?.name,
    path: "/cart",
    meta: cartGiCcjada9VMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart.vue"),
    children: [
  {
    name: "cart-delivery___cs",
    path: "/kosik/doruceni",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/delivery.vue")
  },
  {
    name: "cart___cs",
    path: "/kosik",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/index.vue")
  },
  {
    name: "cart-payment-summary___cs",
    path: "/kosik/shrnuti-platby",
    meta: payment_45summaryaFmU9qqADHMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/payment-summary.vue")
  },
  {
    name: "cart-shipping-and-payment___cs",
    path: "/kosik/doprava-a-platba",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/shipping-and-payment.vue")
  },
  {
    name: "cart-summary___cs",
    path: "/kosik/shrnuti",
    meta: summaryW53CX9JalVMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/summary.vue")
  }
]
  },
  {
    name: cartGiCcjada9VMeta?.name,
    path: "/cart",
    meta: cartGiCcjada9VMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart.vue"),
    children: [
  {
    name: "cart-delivery___sk",
    path: "/kosik/dorucenie",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/delivery.vue")
  },
  {
    name: "cart___sk",
    path: "/kosik",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/index.vue")
  },
  {
    name: "cart-payment-summary___sk",
    path: "/kosik/zhrnutie-platby",
    meta: payment_45summaryaFmU9qqADHMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/payment-summary.vue")
  },
  {
    name: "cart-shipping-and-payment___sk",
    path: "/kosik/doprava-a-platba",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/shipping-and-payment.vue")
  },
  {
    name: "cart-summary___sk",
    path: "/kosik/zhrnutie",
    meta: summaryW53CX9JalVMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/summary.vue")
  }
]
  },
  {
    name: cartGiCcjada9VMeta?.name,
    path: "/cart",
    meta: cartGiCcjada9VMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart.vue"),
    children: [
  {
    name: "cart-delivery___en",
    path: "delivery",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/delivery.vue")
  },
  {
    name: "cart___en",
    path: "/my-cart",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/index.vue")
  },
  {
    name: "cart-payment-summary___en",
    path: "payment-summary",
    meta: payment_45summaryaFmU9qqADHMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/payment-summary.vue")
  },
  {
    name: "cart-shipping-and-payment___en",
    path: "shipping-and-payment",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/shipping-and-payment.vue")
  },
  {
    name: "cart-summary___en",
    path: "summary",
    meta: summaryW53CX9JalVMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/cart/summary.vue")
  }
]
  },
  {
    name: "customer___cs",
    path: "/customer",
    meta: customerFdSSXYej6eMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer.vue"),
    children: [
  {
    name: "customer-account___cs",
    path: "/zakaznik/informace-o-uctu",
    meta: accountZ04vUrTNJPMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/account.vue")
  },
  {
    name: "customer-dashboard___cs",
    path: "/zakaznik/dashboard",
    meta: dashboardYhCq46WyD4Meta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/dashboard.vue")
  },
  {
    name: "customer-favorite-products___cs",
    path: "/zakaznik/oblibene-produkty",
    meta: favorite_45productsQZ3R45QIPkMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/favorite-products.vue")
  },
  {
    name: "customer-my-addresses___cs",
    path: "/zakaznik/adresar",
    meta: my_45addressesbumAp6EGtkMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-addresses.vue")
  },
  {
    name: my_45ordersRlXvFm5K0LMeta?.name,
    path: "/zakaznik/moje-objednavky",
    meta: my_45ordersRlXvFm5K0LMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders.vue"),
    children: [
  {
    name: "customer-my-orders-id___cs",
    path: "/zakaznik/objednavka/:id()",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/[id].vue")
  },
  {
    name: "customer-my-orders___cs",
    path: "",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/index.vue")
  }
]
  }
]
  },
  {
    name: "customer___sk",
    path: "/customer",
    meta: customerFdSSXYej6eMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer.vue"),
    children: [
  {
    name: "customer-account___sk",
    path: "/zakaznik/informacie-o-ucte",
    meta: accountZ04vUrTNJPMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/account.vue")
  },
  {
    name: "customer-dashboard___sk",
    path: "/zakaznik/dashboard",
    meta: dashboardYhCq46WyD4Meta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/dashboard.vue")
  },
  {
    name: "customer-favorite-products___sk",
    path: "/zakaznik/oblubene-produkty",
    meta: favorite_45productsQZ3R45QIPkMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/favorite-products.vue")
  },
  {
    name: "customer-my-addresses___sk",
    path: "/zakaznik/adresar",
    meta: my_45addressesbumAp6EGtkMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-addresses.vue")
  },
  {
    name: my_45ordersRlXvFm5K0LMeta?.name,
    path: "/zakaznik/moje-objednavky",
    meta: my_45ordersRlXvFm5K0LMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders.vue"),
    children: [
  {
    name: "customer-my-orders-id___sk",
    path: "/zakaznik/objednavka/:id()",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/[id].vue")
  },
  {
    name: "customer-my-orders___sk",
    path: "",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/index.vue")
  }
]
  }
]
  },
  {
    name: "customer___en",
    path: "/customer",
    meta: customerFdSSXYej6eMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer.vue"),
    children: [
  {
    name: "customer-account___en",
    path: "account",
    meta: accountZ04vUrTNJPMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/account.vue")
  },
  {
    name: "customer-dashboard___en",
    path: "dashboard",
    meta: dashboardYhCq46WyD4Meta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/dashboard.vue")
  },
  {
    name: "customer-favorite-products___en",
    path: "favorite-products",
    meta: favorite_45productsQZ3R45QIPkMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/favorite-products.vue")
  },
  {
    name: "customer-my-addresses___en",
    path: "my-addresses",
    meta: my_45addressesbumAp6EGtkMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-addresses.vue")
  },
  {
    name: my_45ordersRlXvFm5K0LMeta?.name,
    path: "my-orders",
    meta: my_45ordersRlXvFm5K0LMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders.vue"),
    children: [
  {
    name: "customer-my-orders-id___en",
    path: "/customer/order/:id()",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/[id].vue")
  },
  {
    name: "customer-my-orders___en",
    path: "",
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/customer/my-orders/index.vue")
  }
]
  }
]
  },
  {
    name: "index___cs",
    path: "/",
    meta: indexeq1O9kIMLeMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/",
    meta: indexeq1O9kIMLeMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexeq1O9kIMLeMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/prihlaseni",
    meta: loginYQ645hBCn8Meta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/login.vue")
  },
  {
    name: "login___sk",
    path: "/prihlasenie",
    meta: loginYQ645hBCn8Meta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginYQ645hBCn8Meta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/login.vue")
  },
  {
    name: "password-reset___cs",
    path: "/obnova-hesla",
    meta: password_45resetACf7izeVLdMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___sk",
    path: "/obnova-hesla",
    meta: password_45resetACf7izeVLdMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/password-reset.vue")
  },
  {
    name: "password-reset___en",
    path: "/password-reset",
    meta: password_45resetACf7izeVLdMeta || {},
    component: () => import("/opt/simploshop/themes/theme-default-clean/app/pages/password-reset.vue")
  }
]